'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hubspotHublyticsTrackerJS = require('hubspot.HublyticsTrackerJS.tracker');

var _hubspotHublyticsTrackerJS2 = _interopRequireDefault(_hubspotHublyticsTrackerJS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _HublyticsTracker$EVE = _hubspotHublyticsTrackerJS2.default.EVENT_CLASSES,
    USAGE = _HublyticsTracker$EVE.USAGE,
    WARNING = _HublyticsTracker$EVE.WARNING,
    ERROR = _HublyticsTracker$EVE.ERROR,
    ACTIVATION = _HublyticsTracker$EVE.ACTIVATION,
    INTERACTION = _HublyticsTracker$EVE.INTERACTION,
    VIEW = _HublyticsTracker$EVE.VIEW,
    CREATION = _HublyticsTracker$EVE.CREATION,
    SIGNUP = _HublyticsTracker$EVE.SIGNUP,
    EXPOSURE = _HublyticsTracker$EVE.EXPOSURE,
    NONE = _HublyticsTracker$EVE.NONE;
exports.default = {
  USAGE: USAGE,
  WARNING: WARNING,
  ERROR: ERROR,
  ACTIVATION: ACTIVATION,
  INTERACTION: INTERACTION,
  VIEW: VIEW,
  CREATION: CREATION,
  SIGNUP: SIGNUP,
  EXPOSURE: EXPOSURE,
  NONE: NONE
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/event-tracking-tools/static-1.15/js/hublytics/hublyticsEventClasses.js
// module id = 309
// module chunks = 0